import { ArrowDownTrayIcon, PlayIcon, StopIcon, TrashIcon } from '@heroicons/react/20/solid'

interface RecordingControlsProps {
  isDraft: boolean
  canDelete: boolean
  canDownloadAudio: boolean
  hasPlayableAudio: boolean
  isPlaying: boolean
  isPreparingPlayback: boolean
  onDelete: () => void
  onDownload: () => void
  onPlay: () => void
  onStop: () => void
}

export function RecordingControls({
  isDraft,
  canDelete,
  canDownloadAudio,
  hasPlayableAudio,
  isPlaying,
  isPreparingPlayback,
  onDelete,
  onDownload,
  onPlay,
  onStop,
}: RecordingControlsProps) {
  return (
    <div className="flex items-center gap-2">
      {canDelete && (
        <button
          onClick={onDelete}
          className="p-2 rounded-lg bg-red-600/20 text-red-400 hover:bg-red-600/30 transition-colors focus:outline-none focus:ring-2 focus:ring-red-400"
          aria-label={isDraft ? 'Delete recording' : 'Delete note'}
        >
          <TrashIcon className="h-5 w-5" />
        </button>
      )}

      {canDownloadAudio && (
        <button
          onClick={onDownload}
          className="p-2 rounded-lg bg-blue-600/20 text-blue-300 hover:bg-blue-600/30 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-400 disabled:cursor-not-allowed disabled:opacity-60"
          aria-label="Download recording"
          disabled={isPreparingPlayback}
        >
          <ArrowDownTrayIcon className="h-5 w-5" />
        </button>
      )}

      {hasPlayableAudio && (
        <>
          {isPlaying ? (
            <button
              onClick={onStop}
              className="p-2 rounded-lg bg-gray-600/20 text-gray-400 hover:bg-gray-600/30 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-400"
              aria-label="Stop recording"
            >
              <StopIcon className="h-5 w-5" />
            </button>
          ) : (
            <button
              onClick={onPlay}
              className="p-2 rounded-lg bg-green-600/20 text-green-400 hover:bg-green-600/30 transition-colors focus:outline-none focus:ring-2 focus:ring-green-400 disabled:cursor-not-allowed disabled:opacity-60"
              aria-label={isPreparingPlayback ? 'Preparing audio' : 'Play recording'}
              disabled={isPreparingPlayback}
            >
              <PlayIcon className="h-5 w-5" />
            </button>
          )}
        </>
      )}
    </div>
  )
}
